import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ReisekostenabrechnungenQuerySorterConfig } from 'fa-kt.types';
import { ReisekostenabrechnungenService } from '../service';

@Component({
  selector: 'fa-kt-reisekostenabrechnungen-sorter',
  templateUrl: './reisekostenabrechnungen-sorter.component.html',
  styleUrls: ['./reisekostenabrechnungen-sorter.component.css'],
})
export class ReisekostenabrechnungenSorterComponent {
  public ReisekostenabrechnungenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public reisekostenabrechnungen: ReisekostenabrechnungenService,
  ) {
    this.ReisekostenabrechnungenSorterConfig = ReisekostenabrechnungenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
